// @ts-nocheck
export const DEVLINK_SCOPE_CLASS =
  "wf-devlink-2aec0318a9c90e260b91c6001e1ef334";
